import CreditsIcon from '@/assets/icons/coins-double.svg';
import { TRIAL_CREDITS_LABEL } from '@/constants/trial';
import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

interface TrialCreditsBadgeProps {
    contentClassName?: string;
    className?: string;
    credits?: number;
    children?: ReactNode;
}

export function TrialCreditsBadge({ contentClassName, className, credits, children }: TrialCreditsBadgeProps) {
    const isTrialStarted = typeof credits !== 'undefined'
    const text = isTrialStarted ? 'Hurry up, you have ' : 'You get';

    return (
        <div className={cn('mt-11 flex justify-center items-center', className)}>
            <div className={cn("inline-flex gap-1 items-center justify-center px-4 py-3 rounded-xl bg-warning/02", contentClassName)}>
                {children ? children : <>
                    <p className='text-black text-sm leading-none tracking-normal'><span>{text}</span> <strong className='font-semibold tracking-normal'>{isTrialStarted ? credits : TRIAL_CREDITS_LABEL}</strong></p>
                    <CreditsIcon className='w-7 h-7' />
                    <p className='text-black text-sm leading-none tracking-normal'><strong className='font-semibold tracking-normal'>Free Credits</strong> until trial ends.</p>
                </>}
            </div>
        </div>
    );
}
